export enum ESquad {
  ZONA_BARCELONA = "Zona Barcelona Ciudad",
  ZONA_METRO_BARCELONA = "Zona Metropolitana Barcelona",
  ZONA_MADRID = "Zona Madrid Ciudad",
  ZONA_METRO_MADRID = "Zona Metropolitana Madrid",
  ZONA_BILBAO_ZARAGOZA_VALENCIA = "Zona Bilbao / Valencia / Zaragoza",
  RESTO_ZONAS = "Resto de zonas",
  BARCELONA = "Barcelona",
  MADRID = "Madrid",
  EUSKADI = "País Vasco",
  OTHER_FAST = "Otros rápidos",
  OTHER_DIFFICULT = "Otros difícil",
  SOUTH_ZONE = "Zona Sur",
  NORTH_ZONE = "Zona Norte",
}

export const SQUADS_ABLE_TO_RUN_BOT = [
  ESquad.ZONA_BARCELONA,
  ESquad.ZONA_METRO_BARCELONA,
  ESquad.ZONA_MADRID,
  ESquad.ZONA_METRO_MADRID,
  ESquad.ZONA_BILBAO_ZARAGOZA_VALENCIA,
  ESquad.RESTO_ZONAS,
  ESquad.BARCELONA,
  ESquad.MADRID,
  ESquad.EUSKADI,
  ESquad.OTHER_FAST,
  ESquad.OTHER_DIFFICULT,
  ESquad.SOUTH_ZONE,
  ESquad.NORTH_ZONE
]
